export default __webpack_public_path__ + "static/media/logoEmporio.f827a901.png";